import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { graphql, withApollo } from 'react-apollo'
import { observer, inject } from 'mobx-react'
import { injectIntl, FormattedMessage } from 'react-intl'
import { withRouter } from 'react-router'
import { Modal, Form, Button, Tag } from 'antd'
import _get from 'lodash/get'
import _filter from 'lodash/filter'
import _omit from 'lodash/omit'

import DeliveryAddressFormModal from './DeliveryAddressFormModal'
import deliveryAddressesQuery from '~/App/graphql/queries/deliveryAddresses.gql'
import deleteDeliveryAddressMutation from '~/App/graphql/mutations/deleteDeliveryAddress.gql'
import updateRegistrationDeliveryAddressMutation from '~/App/graphql/mutations/updateRegistrationDeliveryAddress.gql'
import DeliveryAddressPreviewBox from '~/App/components/DeliveryAddressPreviewBox'

import './styles.css'

@Form.create()
@withRouter
@withApollo
@inject('i18n')
@observer
@graphql(deliveryAddressesQuery, {
  options: () => ({
    fetchPolicy: 'network-only'
  })
})
@graphql(updateRegistrationDeliveryAddressMutation, {
  name: 'updateRegistrationDeliveryAddressMutation'
})
@graphql(deleteDeliveryAddressMutation, {
  name: 'deleteDeliveryAddressMutation'
})
@injectIntl
class DeliveryAddressModal extends Component {
  submitting = false
  onClose = e => {
    const { registration, history } = this.props
    history.push(`/reg/${registration._id}/preview`)
  }
  handleSelectDeliveryAddress = e => {
    this.submitting = true
    e.preventDefault()
    const { registration, data: { deliveryAddresses }, updateRegistrationDeliveryAddressMutation } = this.props
    const daId = e.target.getAttribute('daid')
    let deliveryAddress = _omit(
      _filter(deliveryAddresses, { _id: daId })[0],
      ['_id', 'userId', 'Symbol(id)', '__typename']
    )
    const record = {
      _id: registration._id,
      deliveryAddress: deliveryAddress
    }
    updateRegistrationDeliveryAddressMutation({
      variables: { record }
    }).then(res => {
      this.props.history.push(
        `/reg/${registration._id}/preview`
      )
    }).catch(e => {
      this.alertError(e)
      this.submitting = false
    })
  }
  alertError = (err) => {
    const { graphQLErrors } = err
    if (graphQLErrors) {
      graphQLErrors.forEach(error => {
        Modal.error({
          title: 'Error',
          content: error.message
        })
      })
    } else {
      Modal.error({
        title: 'Error',
        content: err.message
      })
    }
  }
  handleDeleteDeliveryAddress = e => {
    const { deleteDeliveryAddressMutation, registration } = this.props
    const daId = e.target.getAttribute('daid')
    deleteDeliveryAddressMutation({
      variables: { _id: daId }
    }).then(res => {
      this.props.history.push(
        `/reg/${registration._id}/preview?dAddr=select`
      )
    }).catch(e => {
      this.alertError(e)
      this.submitting = true
    })
  }
  render () {
    const {
      event,
      registration,
      form,
      dAddrId,
      data,
      i18n: { locale },
      visible,
      customMessage
    } = this.props
    const {
      getFieldDecorator
    } = form

    event && getFieldDecorator('eventId', { initialValue: _get(event, '_id') })
    registration && getFieldDecorator('registrationId', { initialValue: _get(registration, '_id') })
    const deliveryAddresses = _get(data, 'deliveryAddresses')
    return (
      <div>
        { dAddrId &&
          <DeliveryAddressFormModal
            dAddrId={dAddrId}
            dAddrIds={deliveryAddresses}
            event={event}
            registration={registration}
            visible={visible}
            customMessage={customMessage}
          />
        }
        { !dAddrId &&
          <Modal
            maskClosable={false}
            visible={visible}
            width={600}
            title={
              ({
                en: `Select deliver address`,
                zh: `Select deliver address`,
                th: `เลือกที่อยู่`
              })[locale]
            }
            onCancel={ !this.submitting ? this.onClose : () => {} }
            id="modal"
            footer={[
              <Button key="close" onClick={this.onClose} loading={this.submitting}>ยกเลิก</Button>,
              ` `,
              <Link to={`/reg/${registration._id}/preview?dAddr=select&dAddrId=new`} key="addDeliveryAddress">
                <Button icon="file-add" className="create">
                  <FormattedMessage id="app.addDeliveryAddress" />
                </Button>
              </Link>
            ]}
          >
            <div ref={ref => { this.modalRef = ref }} >
              <div>
                {customMessage && <Tag color="orange" className="status">
                  {customMessage}
                </Tag>}
                <div className="deliveryAddressOptionBoxes">
                  { deliveryAddresses && deliveryAddresses.map((da) => {
                    return <div className="deliveryAddressOptionBox" key={da._id}>
                      <DeliveryAddressPreviewBox deliveryAddress={da} locale={locale} />
                      <div>
                        <Button icon="mail" size="small" type="primary"
                          onClick={this.handleSelectDeliveryAddress}
                          loading={this.submitting} daid={da._id}>
                          <FormattedMessage id="app.deliverToThisAddress" />
                        </Button>
                        {` `}
                        <Link to={`/reg/${registration._id}/preview?dAddr=select&dAddrId=${da._id}`}>
                          <Button icon="edit" size="small" className="edit"/>
                        </Link>
                        {` `}
                        <Button icon="delete" size="small" className="delete"
                          onClick={this.handleDeleteDeliveryAddress}
                          loading={this.submitting} daid={da._id}/>
                      </div>
                    </div>
                  })}
                </div>
              </div>
            </div>
          </Modal>
        }
      </div>
    )
  }
}

export default DeliveryAddressModal



// WEBPACK FOOTER //
// ./src/App/components/DeliveryAddressModal/DeliveryAddressModal.js